document.addEventListener('DOMContentLoaded', function () {
  console.log('[PACK ATC] Script chargé');

  const selector = document.getElementById(
    'pack-selector-{{ block.id }}'
  );

  console.log('[PACK ATC] selector:', selector);

  if (!selector) return;

  const sectionId = selector.dataset.sectionId;

  const form =
    document.querySelector(
      `form[id^="product-form-${sectionId}"]`
    ) ||
    selector
      .closest('section')
      ?.querySelector(
        'form[action*="/cart/add"] button[name="add"]'
      )
      ?.closest('form') ||
    Array.from(
      document.querySelectorAll(
        'form[action*="/cart/add"]'
      )
    ).find(function (item) {
      return (
        !String(item.id || '').includes('installment') &&
        !String(item.id || '').includes('sticky') &&
        item.querySelector('button[name="add"]')
      );
    });

  console.log('[PACK ATC] form choisi:', form);

  if (!form) return;

  const button = form.querySelector(
    'button[name="add"]'
  );

  const atcText = form.querySelector(
    '.x-atc-text, .button-text'
  );

  const qtyInput = form.querySelector(
    '#pack-quantity, input[name="quantity"]'
  );

  console.log('[PACK ATC] button:', button);
  console.log('[PACK ATC] atcText:', atcText);
  console.log('[PACK ATC] qtyInput:', qtyInput);

  if (!button || !atcText) return;

  let savingText = form.querySelector(
    '.pack-atc-saving'
  );

  if (!savingText) {
    savingText = document.createElement('div');
    savingText.className = 'pack-atc-saving';
    button.insertAdjacentElement(
      'afterend',
      savingText
    );
  }

  function updateStickyButtonFromPack(card) {
  if (!card) return;

  const sticky =
    document.getElementById(`sticky-add-to-cart-${sectionId}`) ||
    document.querySelector('.sticky_add_to_cart');

  if (!sticky) return;

  const price = card.dataset.price || '';
  const compare = card.dataset.compare || '';

  /*
   * Empêche le script générique de réinjecter
   * le prix unitaire de la variante.
   */
  sticky.dataset.packPriceActive = 'true';

  sticky
    .querySelectorAll('.sticky-atc-button-price')
    .forEach(function (priceContainer) {
      const visiblePrice = priceContainer.querySelector(
        '.sticky-atc-button-current-price .price'
      );

      const comparePrice = priceContainer.querySelector(
        '.sticky-atc-button-compare-price'
      );

      const targetPrice = priceContainer.querySelector(
        '.target-price'
      );

      const targetComparePrice = priceContainer.querySelector(
        '.target-compare-at-price'
      );

      if (visiblePrice) {
        visiblePrice.textContent = price;
      }

      if (comparePrice) {
        comparePrice.textContent = compare;
        comparePrice.hidden = !compare;
      }

      if (targetPrice && card.dataset.priceRaw) {
        targetPrice.textContent = card.dataset.priceRaw;
      }

      if (targetComparePrice) {
        targetComparePrice.textContent =
          card.dataset.compareRaw || '';
      }
    });
}

  function updateButtonFromPack(card) {
  if (!card) return;

  const price = card.dataset.price || '';
  const compare = card.dataset.compare || '';
  const qty = card.dataset.qty || '';

  const discountEl = card.querySelector('.pack-discount');
  const discount = discountEl
    ? discountEl.textContent.trim()
    : '';

  if (qtyInput && qty) {
    qtyInput.value = qty;

    qtyInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

    qtyInput.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );
  }

  atcText.innerHTML = `
    AJOUTER AU PANIER

    <span class="pack-atc-prices">
      ${
        compare
          ? `<span class="pack-atc-compare">${compare}</span>`
          : ''
      }

      ${
        price
          ? `<span class="pack-atc-price">${price}</span>`
          : ''
      }
    </span>
  `;

  savingText.textContent = discount
    ? `Vous économisez ${discount}`
    : '';

  savingText.style.display = discount
    ? 'block'
    : 'none';

  updateStickyButtonFromPack(card);
}

  const cards =
    selector.querySelectorAll('.pack-card');

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      cards.forEach(function (item) {
        item.classList.remove('active');
      });

      card.classList.add('active');
      updateButtonFromPack(card);
    });
  });

  const activeCard =
    selector.querySelector('.pack-card.active') ||
    selector.querySelector('.pack-card');

  updateButtonFromPack(activeCard);
});
function updateStickyButtonFromPack(card) {
  if (!card) return;

  const price = card.dataset.price || '';
  const compare = card.dataset.compare || '';

  const sticky =
    document.getElementById(`sticky-add-to-cart-${sectionId}`) ||
    document.querySelector('.sticky_add_to_cart');

  if (!sticky) {
    console.warn('[PACK ATC] Sticky introuvable');
    return;
  }

  const update = function () {
    const priceContainers = sticky.querySelectorAll(
      '.sticky-atc-button-price'
    );

    console.log(
      '[PACK ATC] Prix sticky :',
      price,
      compare,
      'conteneurs :',
      priceContainers.length
    );

    priceContainers.forEach(function (container) {
      const currentPrice = container.querySelector(
        '.sticky-atc-button-current-price .price'
      );

      const comparePrice = container.querySelector(
        '.sticky-atc-button-compare-price'
      );

      if (currentPrice) {
        currentPrice.textContent = price;
      }

      if (comparePrice) {
        comparePrice.textContent = compare;
        comparePrice.hidden = !compare;
      }
    });
  };


  update();


  requestAnimationFrame(update);
  window.setTimeout(update, 50);
  window.setTimeout(update, 150);
}
